import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-product-card-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './product-card-skeleton.html',
  styleUrl: './product-card-skeleton.scss'
})
export class ProductCardSkeleton {}

